<template>
  <div>
    <h1>Configurador de Abastecimentos</h1>
    <b-button variant="sm" class="btn-checklist mb-3" @click="prevPage">
      {{ $t("checklist.form.backToList") }}
    </b-button>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    <b-row>
      <b-col cols="6" style="max-width: 600px">
        <FuelSupplyFormConfigurationForm
          :initial-config="config"
          @on-save="handleSave"
        />
      </b-col>
      <b-col cols="6">
        <FuelSupplyFieldConfiguration
          :config="config.fuelSupplyFieldConfigurations"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "FuelSupplyFormConfigurationPage",
  components: {
    FuelSupplyFormConfigurationForm: () =>
      import(
        "@/components_rms/vehicle/FuelSupplyFormConfiguration/FuelSupplyFormConfigurationForm.vue"
      ),
    FuelSupplyFieldConfiguration: () =>
      import(
        "@/components_rms/vehicle/FuelSupplyFormConfiguration/FuelSupplyFieldConfiguration.vue"
      ),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      config: null,
      alert: {
        error: "",
        success: "",
      },
      submitted: false,
    };
  },
  async mounted() {
    this.submitted = true;
    this.$apiChecklist
      .get("fuelSupply/getConfiguration/byCompanyId")
      .then((response) => {
        this.config = response.data;
        this.submitted = false;
      })
      .catch((error) => {
        console.error(error);
        this.alert.error = "Erro ao carregar configuração";
        this.$refs.fadeAlertDanger.show();
        this.submitted = false;
      });
  },
  methods: {
    async handleSave(updatedConfig) {
      console.log(updatedConfig);
      this.submitted = true;
      this.$apiChecklist
        .post("fuelSupply/save", updatedConfig)
        .then((response) => {
          this.config = response.data;
          this.alert.success = "Configuração salva com sucesso!";
          this.$refs.alert.show();
          this.submitted = false;
        })
        .catch((error) => {
          console.error(error);
          this.alert.error = "Erro ao salvar configuração";
          this.$refs.fadeAlertDanger.show();
          this.submitted = false;
        });
    },
    prevPage() {
      this.$router.push("/checklist/fuelSupply/list");
    },
  },
};
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
